import { http, HttpResponse } from 'msw';
import fakeSocialMediaData from 'domains/Shell/Footer/FakeSocialMediaData.json';

export const socialMediaHandlers = [
  http.get('*/api/theme/sites/*/branding-theme/social', () => {
    return HttpResponse.json(fakeSocialMediaData, { status: 200 });
  }),
];
